import firebase from "firebase/compat/app";
import { Result } from '../../shared/types';

export async function acceptPaymentTerms(data: { firstName?: string, lastName?: string, userId?: string, clientId?: string }): Promise<Result> {
    const acceptPaymentTerms = firebase.functions().httpsCallable('acceptPaymentTerms');

    try {
        const res = await acceptPaymentTerms(data);
        return {
            success: true,
            result: res,
        }
    } catch (e) {
        console.log(e);
        return {
            success: false,
            error: e,
        }
    }
}

export async function sendNewClientForm(clientId: string, email: string): Promise<Result> {
    const sendNewClientForm = firebase.functions().httpsCallable('sendNewClientForm');

    try {
        const res = await sendNewClientForm({ clientId, email });
        return {
            success: true,
            result: res,
        }
    } catch (e) {
        console.log(e);
        return {
            success: false,
            error: e,
        }
    }
}

export async function exportListToGoogleSheet(data: {
    listId: string;
    title: string;
    values: string[][];
    /** Currency symbol for Price columns in the exported sheet (default `$`). */
    currencySymbol?: string;
}): Promise<Result> {
    const exportListToGoogleSheetFn = firebase.functions().httpsCallable('exportListToGoogleSheet');

    try {
        const res = await exportListToGoogleSheetFn(data);
        const payload = res.data as { spreadsheetUrl?: string };
        return {
            success: true,
            result: payload,
        };
    } catch (e) {
        console.log(e);
        return {
            success: false,
            error: e,
        };
    }
}
